export default __webpack_public_path__ + "static/badminton-daaji-img-7384c9f4d84a8a9373c5cc17d9941991.png";